export const SUBCONTRACT_GRID_TOTAL_ROW_ID = 'total';
